/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_SubtitleInputs */

const en_landing_preview_subtitle = /** @type {(inputs: Landing_Preview_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every note indexed, entitled, and ready to query.`)
};

/**
* | output |
* | --- |
* | "Every note indexed, entitled, and ready to query." |
*
* @param {Landing_Preview_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_subtitle = /** @type {((inputs?: Landing_Preview_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_subtitle(inputs)
});